export default (axios, baseURL) => async (clientSid, appClientId) => {
  const url = `/hub/clients/${encodeURIComponent(clientSid)}/hub-config/${encodeURIComponent(appClientId)}`;

  const axiosConfig = {
    method: 'DELETE',
    baseURL,
    url
  };

  const axiosResponse = await axios(axiosConfig);

  if (!axiosResponse || !axiosResponse.data || typeof axiosResponse.data !== 'object') {
    throw new Error('Invalid response from gateway');
  }
  return axiosResponse.data;
};
